import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const TimeNavbar = () => {
  const { t } = useLocalize()
  return (
    <div className="tw-bg-base-200 tw-px-5 tw-py-3">
      <p className="tw-text-sm tw-font-medium tw-text-content-base">
        {t('driverModule.available-working-time')}
      </p>
    </div>
  )
}

export default TimeNavbar
